import { html, nothing, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseComponent } from '../../base-component/base-component';
import { OffCanvasConfigs } from '../../off-canvas/interfaces/off-canvas.interface';
import { WISH_LIST_OFF_CANVAS_IDS } from '../interfaces/wish-list-off-canvas.interface';
import '../../off-canvas/off-canvas';
import '../../wish-list/components/wish-list-create';

@customElement('mhecomm-wish-list-update-off-canvas')
export class WishListUpdateOffCanvas extends BaseComponent {

  @property()
  offCanvasTitle = 'Edit List Name';

  @property({type: Number})
  wishListId;

  @property()
  wishListName;

  @property({type: Boolean})
  isWishListItemPage = false;

  /**
   * Displays the off-canvas for creating a wishlist.
   */
  renderComp(): TemplateResult | typeof nothing {
    return html`
      <mhecomm-off-canvas .offCanvasConfigs="${this.getOffCanvasConfigs()}">
        <div slot=${WISH_LIST_OFF_CANVAS_IDS.UPDATE_WISH_LIST_MY_LISTS + "-off-canvas-body"}>
          <mhecomm-create-wish-list 
            offCanvasId="${WISH_LIST_OFF_CANVAS_IDS.UPDATE_WISH_LIST_MY_LISTS}"
            wishListId=${this.wishListId}
            wishListName=${this.wishListName}
            ?isEditWishList=${true}
            ?isWishListItemPage=${this.isWishListItemPage}
          ></mhecomm-create-wish-list>
        </div>
      </mhecomm-off-canvas>
    `
  }

  /**
   * Returns the off-canvas configs for the component.
   *
   * This configuration is updated based on the states.
   */
  private getOffCanvasConfigs(): OffCanvasConfigs {
    return {
      [WISH_LIST_OFF_CANVAS_IDS.UPDATE_WISH_LIST_MY_LISTS]: {
        id: WISH_LIST_OFF_CANVAS_IDS.UPDATE_WISH_LIST_MY_LISTS,
        title: html`<h5 class="mb-0">${this.offCanvasTitle}</h5>`,
        closeTriggerId: 'cancelWishlistUpdationBtn',
        focusElement: '#editWishListName'
      }
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-wish-list-update-off-canvas': WishListUpdateOffCanvas;
  }
}